module.exports = __webpack_public_path__ + "img/p4_1.873f1a62.png";